module.exports = __webpack_public_path__ + "img/stack.7f748fd6.png";